module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "documents-global"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "head"
  }, [_c('div', {
    staticClass: "title-head mr-3"
  }, [_vm._v("ESPACE DOCUMENTAIRE")]), _vm._v(" "), (_vm.dossierRacine != undefined) ? _c('Button', {
    attrs: {
      "color": "green",
      "title": "Créer un dossier",
      "icon": "fa-solid fa-folder-plus",
      "isOutline": "true"
    },
    on: {
      "click": function($event) {
        _vm.ajouterDossier(_vm.dossierRacine)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.nombreDocumentsSelectionnes > 0 || _vm.nombreDossiersSelectionnes > 0) ? _c('div', {
    staticClass: "tw-h-full tw-w-px tw-bg-gray-300 tw-py-1 tw-mx-3"
  }) : _vm._e(), _vm._v(" "), (_vm.nombreDocumentsSelectionnes > 0 || _vm.nombreDossiersSelectionnes > 0) ? _c('Button', {
    staticClass: "mr-3",
    attrs: {
      "color": "blue",
      "title": "Tout désélectionner",
      "icon": "fa-solid fa-square-minus",
      "isOutline": "true"
    },
    on: {
      "click": function($event) {
        _vm.selectionnerCascade(_vm.dossierRacine, false)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.nombreDocumentsSelectionnes > 0 || _vm.nombreDossiersSelectionnes > 0) ? _c('Button', {
    staticClass: "mr-3",
    attrs: {
      "color": "blue",
      "title": "Télécharger",
      "icon": "fa-solid fa-download",
      "isOutline": "true"
    },
    on: {
      "click": function($event) {
        _vm.telechargerSelection()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.nombreDocumentsSelectionnes > 0 || _vm.nombreDossiersSelectionnes > 0) ? _c('Button', {
    attrs: {
      "color": "red",
      "title": "Supprimer",
      "icon": "fa-solid fa-trash-can",
      "isOutline": "true"
    },
    on: {
      "click": function($event) {
        _vm.supprimerSelection()
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "card p-3"
  }, [(_vm.dataReady) ? _c('div', {
    staticClass: "treeview noselect"
  }, _vm._l((_vm.dossierRacine.SousDossier), function(dossier) {
    return _c('div', {
      class: (dossier.isOpen) ? 'tree-row open ' : 'tree-row'
    }, [_c('div', {
      staticClass: "tree-head"
    }, [_c('div', {
      staticClass: "active-panel",
      class: dossier.isLoading ? 'tw-cursor-default' : '',
      on: {
        "click": function($event) {
          _vm.toggleOpen(dossier)
        }
      }
    }, [_c('div', {
      staticClass: "left-tree-row"
    }, [_c('span', {
      staticClass: "fas fa-fw",
      class: (dossier.isOpen) ? 'fa-angle-down' : 'fa-angle-right'
    }), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (dossier.isSelected),
        expression: "dossier.isSelected"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(dossier.isSelected) ? _vm._i(dossier.isSelected, null) > -1 : (dossier.isSelected)
      },
      on: {
        "click": function($event) {
          _vm.selectionnerDossier(dossier, $event)
        },
        "change": function($event) {
          var $$a = dossier.isSelected,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(dossier, "isSelected", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(dossier, "isSelected", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(dossier, "isSelected", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "icon-folder fa-fw",
      class: (dossier.isOpen) ? 'far fa-folder-open ' : 'fas fa-folder'
    })]), _vm._v(" "), _c('span', {
      staticClass: "dossier-name pr-3",
      attrs: {
        "title": dossier.Nom
      }
    }, [_vm._v(_vm._s(dossier.Nom))]), _vm._v(" "), _c('div', {
      staticClass: "align-right-head"
    }, [_c('span', {
      staticClass: "icon-add-folder fas fa-folder-plus fa-fw",
      attrs: {
        "title": "Créer un dossier"
      },
      on: {
        "click": function($event) {
          _vm.ajouterDossier(dossier)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "icon-add-file fas fa-file-medical fa-fw",
      attrs: {
        "title": "Ajouter un document"
      },
      on: {
        "click": function($event) {
          _vm.ajouterDocument(dossier)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "icon-delete fas fa-trash-alt fa-fw",
      attrs: {
        "title": "Supprimer le dossier"
      },
      on: {
        "click": function($event) {
          _vm.confirmerSuppressionDossier(dossier.CheminLogique, _vm.dossierRacine)
        }
      }
    })])])]), _vm._v(" "), (dossier.isLoading && dossier.isOpen) ? _c('div', {
      staticClass: "tree-skeleton"
    }, [_vm._m(0, true)]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "tree-body"
    }, [(!dossier.isLoading && dossier.isOpen && _vm.estDossierVide(dossier)) ? _c('div', {
      staticClass: "empty-folder"
    }, [_vm._v("\n                                    Aucun contenu à afficher\n                                ")]) : _vm._e(), _vm._v(" "), _vm._l((dossier.SousDossier), function(sousDossier) {
      return _c('div', {
        class: (sousDossier.isOpen) ? 'tree-row open ' : 'tree-row'
      }, [_c('div', {
        staticClass: "tree-head"
      }, [_c('div', {
        staticClass: "active-panel",
        class: sousDossier.isLoading ? 'tw-cursor-default' : '',
        on: {
          "click": function($event) {
            _vm.toggleOpen(sousDossier)
          }
        }
      }, [_c('div', {
        staticClass: "left-tree-row"
      }, [_c('span', {
        staticClass: "fas fa-fw",
        class: (sousDossier.isOpen) ? 'fa-angle-down' : 'fa-angle-right'
      }), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (sousDossier.isSelected),
          expression: "sousDossier.isSelected"
        }],
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "checked": Array.isArray(sousDossier.isSelected) ? _vm._i(sousDossier.isSelected, null) > -1 : (sousDossier.isSelected)
        },
        on: {
          "click": function($event) {
            _vm.selectionnerDossier(sousDossier, $event)
          },
          "change": function($event) {
            var $$a = sousDossier.isSelected,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(sousDossier, "isSelected", $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(sousDossier, "isSelected", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(sousDossier, "isSelected", $$c)
            }
          }
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "icon-folder fa-fw",
        class: (sousDossier.isOpen) ? 'far fa-folder-open ' : 'fas fa-folder'
      })]), _vm._v(" "), _c('span', {
        staticClass: "dossier-name pr-3",
        attrs: {
          "title": sousDossier.Nom
        }
      }, [_vm._v(_vm._s(sousDossier.Nom))]), _vm._v(" "), _c('div', {
        staticClass: "align-right-head"
      }, [_c('span', {
        staticClass: "icon-add-folder fas fa-folder-plus fa-fw",
        attrs: {
          "title": "Créer un dossier"
        },
        on: {
          "click": function($event) {
            _vm.ajouterDossier(sousDossier)
          }
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "icon-add-file fas fa-file-medical fa-fw",
        attrs: {
          "title": "Ajouter un document"
        },
        on: {
          "click": function($event) {
            _vm.ajouterDocument(sousDossier)
          }
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "icon-delete fas fa-trash-alt fa-fw",
        attrs: {
          "title": "Supprimer le dossier"
        },
        on: {
          "click": function($event) {
            _vm.confirmerSuppressionDossier(sousDossier.CheminLogique, dossier)
          }
        }
      })])])]), _vm._v(" "), (sousDossier.isLoading && sousDossier.isOpen) ? _c('div', {
        staticClass: "tree-skeleton"
      }, [_vm._m(1, true)]) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "tree-body"
      }, [(!sousDossier.isLoading && sousDossier.isOpen && _vm.estDossierVide(sousDossier)) ? _c('div', {
        staticClass: "empty-folder"
      }, [_vm._v("\n                                            Aucun contenu à afficher\n                                        ")]) : _vm._e(), _vm._v(" "), _vm._l((sousDossier.SousDossier), function(sousSousDossier) {
        return _c('div', {
          class: (sousSousDossier.isOpen) ? 'tree-row open ' : 'tree-row'
        }, [_c('div', {
          staticClass: "tree-head"
        }, [_c('div', {
          staticClass: "active-panel",
          class: sousSousDossier.isLoading ? 'tw-cursor-default' : '',
          on: {
            "click": function($event) {
              _vm.toggleOpen(sousSousDossier)
            }
          }
        }, [_c('div', {
          staticClass: "left-tree-row"
        }, [_c('span', {
          staticClass: "fas fa-fw",
          class: (sousSousDossier.isOpen) ? 'fa-angle-down' : 'fa-angle-right'
        }), _vm._v(" "), _c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (sousSousDossier.isSelected),
            expression: "sousSousDossier.isSelected"
          }],
          attrs: {
            "type": "checkbox"
          },
          domProps: {
            "checked": Array.isArray(sousSousDossier.isSelected) ? _vm._i(sousSousDossier.isSelected, null) > -1 : (sousSousDossier.isSelected)
          },
          on: {
            "click": function($event) {
              _vm.selectionnerDossier(sousSousDossier, $event)
            },
            "change": function($event) {
              var $$a = sousSousDossier.isSelected,
                $$el = $event.target,
                $$c = $$el.checked ? (true) : (false);
              if (Array.isArray($$a)) {
                var $$v = null,
                  $$i = _vm._i($$a, $$v);
                if ($$el.checked) {
                  $$i < 0 && (_vm.$set(sousSousDossier, "isSelected", $$a.concat([$$v])))
                } else {
                  $$i > -1 && (_vm.$set(sousSousDossier, "isSelected", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
                }
              } else {
                _vm.$set(sousSousDossier, "isSelected", $$c)
              }
            }
          }
        }), _vm._v(" "), _c('span', {
          staticClass: "icon-folder fa-fw",
          class: (sousSousDossier.isOpen) ? 'far fa-folder-open ' : 'fas fa-folder'
        })]), _vm._v(" "), _c('span', {
          staticClass: "dossier-name pr-3",
          attrs: {
            "title": sousSousDossier.Nom
          }
        }, [_vm._v(_vm._s(sousSousDossier.Nom))]), _vm._v(" "), _c('div', {
          staticClass: "align-right-head"
        }, [_c('span', {
          staticClass: "icon-add-folder fas fa-folder-plus fa-fw",
          attrs: {
            "title": "Créer un dossier"
          },
          on: {
            "click": function($event) {
              _vm.ajouterDossier(sousSousDossier)
            }
          }
        }), _vm._v(" "), _c('span', {
          staticClass: "icon-add-file fas fa-file-medical fa-fw",
          attrs: {
            "title": "Ajouter un document"
          },
          on: {
            "click": function($event) {
              _vm.ajouterDocument(sousSousDossier)
            }
          }
        }), _vm._v(" "), _c('span', {
          staticClass: "icon-delete fas fa-trash-alt fa-fw",
          attrs: {
            "title": "Supprimer le dossier"
          },
          on: {
            "click": function($event) {
              _vm.confirmerSuppressionDossier(sousSousDossier.CheminLogique, sousDossier)
            }
          }
        })])])]), _vm._v(" "), (sousSousDossier.isLoading && sousSousDossier.isOpen) ? _c('div', {
          staticClass: "tree-skeleton"
        }, [_vm._m(2, true)]) : _vm._e(), _vm._v(" "), _c('div', {
          staticClass: "tree-body"
        }, [(!sousSousDossier.isLoading && sousSousDossier.isOpen && _vm.estDossierVide(sousSousDossier)) ? _c('div', {
          staticClass: "empty-folder"
        }, [_vm._v("\n                                                    Aucun contenu à afficher\n                                                ")]) : _vm._e(), _vm._v(" "), _vm._l((sousSousDossier.SousDossier), function(sousSousSousDossier) {
          return _c('div', {
            class: (sousSousSousDossier.isOpen) ? 'tree-row open ' : 'tree-row'
          }, [_c('div', {
            staticClass: "tree-head"
          }, [_c('div', {
            staticClass: "active-panel",
            class: sousSousSousDossier.isLoading ? 'tw-cursor-default' : '',
            on: {
              "click": function($event) {
                _vm.toggleOpen(sousSousSousDossier)
              }
            }
          }, [_c('div', {
            staticClass: "left-tree-row"
          }, [_c('span', {
            staticClass: "fas fa-fw",
            class: (sousSousSousDossier.isOpen) ? 'fa-angle-down' : 'fa-angle-right'
          }), _vm._v(" "), _c('input', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (sousSousSousDossier.isSelected),
              expression: "sousSousSousDossier.isSelected"
            }],
            attrs: {
              "type": "checkbox"
            },
            domProps: {
              "checked": Array.isArray(sousSousSousDossier.isSelected) ? _vm._i(sousSousSousDossier.isSelected, null) > -1 : (sousSousSousDossier.isSelected)
            },
            on: {
              "click": function($event) {
                _vm.selectionnerDossier(sousSousSousDossier, $event)
              },
              "change": function($event) {
                var $$a = sousSousSousDossier.isSelected,
                  $$el = $event.target,
                  $$c = $$el.checked ? (true) : (false);
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v);
                  if ($$el.checked) {
                    $$i < 0 && (_vm.$set(sousSousSousDossier, "isSelected", $$a.concat([$$v])))
                  } else {
                    $$i > -1 && (_vm.$set(sousSousSousDossier, "isSelected", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
                  }
                } else {
                  _vm.$set(sousSousSousDossier, "isSelected", $$c)
                }
              }
            }
          }), _vm._v(" "), _c('span', {
            staticClass: "icon-folder fa-fw",
            class: (sousSousSousDossier.isOpen) ? 'far fa-folder-open ' : 'fas fa-folder'
          })]), _vm._v(" "), _c('span', {
            staticClass: "dossier-name pr-3",
            attrs: {
              "title": sousSousSousDossier.Nom
            }
          }, [_vm._v(_vm._s(sousSousSousDossier.Nom))]), _vm._v(" "), _c('div', {
            staticClass: "align-right-head"
          }, [_c('span', {
            staticClass: "icon-add-file fas fa-file-medical fa-fw",
            attrs: {
              "title": "Ajouter un document"
            },
            on: {
              "click": function($event) {
                _vm.ajouterDocument(sousSousSousDossier)
              }
            }
          }), _vm._v(" "), _c('span', {
            staticClass: "icon-delete fas fa-trash-alt fa-fw",
            attrs: {
              "title": "Supprimer le dossier"
            },
            on: {
              "click": function($event) {
                _vm.confirmerSuppressionDossier(sousSousSousDossier.CheminLogique, sousSousDossier)
              }
            }
          })])])]), _vm._v(" "), (sousSousSousDossier.isLoading && sousSousSousDossier.isOpen) ? _c('div', {
            staticClass: "tree-skeleton"
          }, [_vm._m(3, true)]) : _vm._e(), _vm._v(" "), _c('div', {
            staticClass: "tree-body"
          }, [(!sousSousSousDossier.isLoading && sousSousSousDossier.isOpen && _vm.estDossierVide(sousSousSousDossier)) ? _c('div', {
            staticClass: "empty-folder"
          }, [_vm._v("\n                                                            Aucun contenu à afficher\n                                                        ")]) : _vm._e(), _vm._v(" "), _vm._l((sousSousSousDossier.Documents), function(document) {
            return _c('div', {
              staticClass: "line",
              class: (document.Code == _vm.currentCode) ? ' active ' : ''
            }, [_c('span', {
              staticClass: "active-panel",
              on: {
                "click": function($event) {
                  _vm.selectDocument(document)
                }
              }
            }, [_c('input', {
              directives: [{
                name: "model",
                rawName: "v-model",
                value: (document.isSelected),
                expression: "document.isSelected"
              }],
              attrs: {
                "type": "checkbox"
              },
              domProps: {
                "checked": Array.isArray(document.isSelected) ? _vm._i(document.isSelected, null) > -1 : (document.isSelected)
              },
              on: {
                "click": function($event) {
                  _vm.selectionnerDocument(document, $event)
                },
                "change": function($event) {
                  var $$a = document.isSelected,
                    $$el = $event.target,
                    $$c = $$el.checked ? (true) : (false);
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v);
                    if ($$el.checked) {
                      $$i < 0 && (_vm.$set(document, "isSelected", $$a.concat([$$v])))
                    } else {
                      $$i > -1 && (_vm.$set(document, "isSelected", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
                    }
                  } else {
                    _vm.$set(document, "isSelected", $$c)
                  }
                }
              }
            }), _vm._v(" "), _c('span', {
              staticClass: "icon-file fas fa-file fa-fw"
            }), _vm._v(" "), _c('span', {
              staticClass: "name pr-3",
              attrs: {
                "title": document.Nom
              }
            }, [_vm._v(_vm._s(document.Nom))]), _vm._v(" "), _c('span', {
              staticClass: "date"
            }, [_vm._v("\n                                                                    " + _vm._s(_vm._f("moment")(document.DateDeModification, "DD/MM/YYYY")) + "\n                                                                ")])]), _vm._v(" "), _c('span', {
              staticClass: "icon-save fas fa-file-download fa-fw",
              attrs: {
                "title": "Télécharger le document"
              },
              on: {
                "click": function($event) {
                  _vm.telechargerDocument(document)
                }
              }
            }), _vm._v(" "), _c('span', {
              staticClass: "icon-delete fas fa-trash-alt fa-fw",
              attrs: {
                "title": "Supprimer le document"
              },
              on: {
                "click": function($event) {
                  _vm.confirmerSuppressionDocument(document.Code, sousSousSousDossier)
                }
              }
            })])
          })], 2)])
        }), _vm._v(" "), _vm._l((sousSousDossier.Documents), function(document) {
          return _c('div', {
            staticClass: "line",
            class: (document.Code == _vm.currentCode) ? ' active ' : ''
          }, [_c('span', {
            staticClass: "active-panel",
            on: {
              "click": function($event) {
                _vm.selectDocument(document)
              }
            }
          }, [_c('input', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (document.isSelected),
              expression: "document.isSelected"
            }],
            attrs: {
              "type": "checkbox"
            },
            domProps: {
              "checked": Array.isArray(document.isSelected) ? _vm._i(document.isSelected, null) > -1 : (document.isSelected)
            },
            on: {
              "click": function($event) {
                _vm.selectionnerDocument(document, $event)
              },
              "change": function($event) {
                var $$a = document.isSelected,
                  $$el = $event.target,
                  $$c = $$el.checked ? (true) : (false);
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v);
                  if ($$el.checked) {
                    $$i < 0 && (_vm.$set(document, "isSelected", $$a.concat([$$v])))
                  } else {
                    $$i > -1 && (_vm.$set(document, "isSelected", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
                  }
                } else {
                  _vm.$set(document, "isSelected", $$c)
                }
              }
            }
          }), _vm._v(" "), _c('span', {
            staticClass: "icon-file fas fa-file fa-fw"
          }), _vm._v(" "), _c('span', {
            staticClass: "name pr-3",
            attrs: {
              "title": document.Nom
            }
          }, [_vm._v(_vm._s(document.Nom))]), _vm._v(" "), _c('span', {
            staticClass: "date"
          }, [_vm._v("\n                                                            " + _vm._s(_vm._f("moment")(document.DateDeModification, "DD/MM/YYYY")) + "\n                                                        ")])]), _vm._v(" "), _c('span', {
            staticClass: "icon-save fas fa-file-download fa-fw",
            attrs: {
              "title": "Télécharger le document"
            },
            on: {
              "click": function($event) {
                _vm.telechargerDocument(document)
              }
            }
          }), _vm._v(" "), _c('span', {
            staticClass: "icon-delete fas fa-trash-alt fa-fw",
            attrs: {
              "title": "Supprimer le document"
            },
            on: {
              "click": function($event) {
                _vm.confirmerSuppressionDocument(document.Code, sousSousDossier)
              }
            }
          })])
        })], 2)])
      }), _vm._v(" "), _vm._l((sousDossier.Documents), function(document) {
        return _c('div', {
          staticClass: "line",
          class: (document.Code == _vm.currentCode) ? ' active ' : ''
        }, [_c('span', {
          staticClass: "active-panel",
          on: {
            "click": function($event) {
              _vm.selectDocument(document)
            }
          }
        }, [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (document.isSelected),
            expression: "document.isSelected"
          }],
          attrs: {
            "type": "checkbox"
          },
          domProps: {
            "checked": Array.isArray(document.isSelected) ? _vm._i(document.isSelected, null) > -1 : (document.isSelected)
          },
          on: {
            "click": function($event) {
              _vm.selectionnerDocument(document, $event)
            },
            "change": function($event) {
              var $$a = document.isSelected,
                $$el = $event.target,
                $$c = $$el.checked ? (true) : (false);
              if (Array.isArray($$a)) {
                var $$v = null,
                  $$i = _vm._i($$a, $$v);
                if ($$el.checked) {
                  $$i < 0 && (_vm.$set(document, "isSelected", $$a.concat([$$v])))
                } else {
                  $$i > -1 && (_vm.$set(document, "isSelected", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
                }
              } else {
                _vm.$set(document, "isSelected", $$c)
              }
            }
          }
        }), _vm._v(" "), _c('span', {
          staticClass: "icon-file fas fa-file fa-fw"
        }), _vm._v(" "), _c('span', {
          staticClass: "name pr-3",
          attrs: {
            "title": document.Nom
          }
        }, [_vm._v(_vm._s(document.Nom))]), _vm._v(" "), _c('span', {
          staticClass: "date"
        }, [_vm._v("\n                                                    " + _vm._s(_vm._f("moment")(document.DateDeModification, "DD/MM/YYYY")) + "\n                                                ")])]), _vm._v(" "), _c('span', {
          staticClass: "icon-save fas fa-file-download fa-fw",
          attrs: {
            "title": "Télécharger le document"
          },
          on: {
            "click": function($event) {
              _vm.telechargerDocument(document)
            }
          }
        }), _vm._v(" "), _c('span', {
          staticClass: "icon-delete fas fa-trash-alt fa-fw",
          attrs: {
            "title": "Supprimer le document"
          },
          on: {
            "click": function($event) {
              _vm.confirmerSuppressionDocument(document.Code, sousDossier)
            }
          }
        })])
      })], 2)])
    }), _vm._v(" "), _vm._l((dossier.Documents), function(document) {
      return _c('div', {
        staticClass: "line",
        class: (document.Code == _vm.currentCode) ? ' active ' : ''
      }, [_c('span', {
        staticClass: "active-panel",
        on: {
          "click": function($event) {
            _vm.selectDocument(document)
          }
        }
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (document.isSelected),
          expression: "document.isSelected"
        }],
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "checked": Array.isArray(document.isSelected) ? _vm._i(document.isSelected, null) > -1 : (document.isSelected)
        },
        on: {
          "click": function($event) {
            _vm.selectionnerDocument(document, $event)
          },
          "change": function($event) {
            var $$a = document.isSelected,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(document, "isSelected", $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(document, "isSelected", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(document, "isSelected", $$c)
            }
          }
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "icon-file fas fa-file fa-fw"
      }), _vm._v(" "), _c('span', {
        staticClass: "name pr-3",
        attrs: {
          "title": document.Nom
        }
      }, [_vm._v(_vm._s(document.Nom))]), _vm._v(" "), _c('span', {
        staticClass: "date"
      }, [_vm._v(_vm._s(_vm._f("moment")(document.DateDeModification, "DD/MM/YYYY")))])]), _vm._v(" "), _c('span', {
        staticClass: "icon-save fas fa-file-download fa-fw",
        attrs: {
          "title": "Télécharger le document"
        },
        on: {
          "click": function($event) {
            _vm.telechargerDocument(document)
          }
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "icon-delete fas fa-trash-alt fa-fw",
        attrs: {
          "title": "Supprimer le document"
        },
        on: {
          "click": function($event) {
            _vm.confirmerSuppressionDocument(document.Code, dossier)
          }
        }
      })])
    })], 2)])
  })) : _c('loader')], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "head"
  }, [_c('div', {
    staticClass: "title-head",
    attrs: {
      "title": ("PRÉVISUALISATION - " + (_vm.currentDocument != null ? _vm.currentDocument.Nom : ''))
    }
  }, [_vm._v("\n                    PRÉVISUALISATION "), (_vm.currentDocument != undefined) ? _c('span', [_vm._v(" - " + _vm._s(_vm.currentDocument.Nom))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "card",
    class: _vm.currentDocument == undefined ? 'p-3' : '',
    staticStyle: {
      "overflow": "hidden"
    }
  }, [(_vm.canPreview) ? _c('div', {
    staticStyle: {
      "height": "100%"
    }
  }, [(_vm.currentData != undefined) ? _c('object', {
    attrs: {
      "data": _vm.currentDataUrl,
      "type": "application/pdf",
      "width": "100%",
      "height": "100%"
    }
  }) : _c('loader', {
    staticClass: "loader"
  })], 1) : _c('div', {
    staticClass: "box"
  }, [_c('span', {
    staticClass: "fas fa-info-circle fa-4x"
  }), _vm._v(" "), _c('span', {
    staticClass: "mt-2",
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("Aucun document sélectionné")])]), _vm._v(" "), (!_vm.isPreviewReady) ? _c('loader') : _vm._e()], 1)])]), _vm._v(" "), _c('modal-ajout-edit-dossier', {
    ref: "modalAjoutEditDossier",
    on: {
      "completed": _vm.fetchData
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "skeleton-animation"
  }, [_c('div', {
    staticClass: "skeleton"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "skeleton-animation"
  }, [_c('div', {
    staticClass: "skeleton"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "skeleton-animation"
  }, [_c('div', {
    staticClass: "skeleton"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "skeleton-animation"
  }, [_c('div', {
    staticClass: "skeleton"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a7589a50"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ged/documents.vue.html
// module id = NGHX
// module chunks = 2